/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    '.shop-by-series': {
        '.Series-Carousel': {
            marginBottom: '32px'
        },

        '.slick-slider': {
            position: 'static',

            '.slick-list': {
                margin: ['0 60px 0 0', '0 150px 0 0'],

                '.slick-track': {
                    display: 'flex',

                    '.slick-slide': {
                        margin: '0 8px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',

                        '.category-block': {
                            margin: '0'
                        }
                    }
                }
            },

            '.slick-arrow': {
                background: 'none',
                top: '8%',
                position: 'absolute',
                width: '40px',
                height: '40px',
                display: ['none !important', 'block !important'],

                '&.slick-prev': {
                    left: 'inherit',
                    right: '8%',
                    transform: 'rotate(180deg)'
                },

                '&.slick-next': {
                    right: '0'
                }
            }
        }
    }
}
